import React, {useEffect} from 'react';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {useHistory} from "react-router-dom";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {getNavigateToPreferencesAndSubscription} from "../../redux/profile/selectors";
import {setNavigateToPreferencesAndSubscription} from "../../redux/profile/slice";



export const SignUpAuthenticatedModal = ({modalName, handleCloseModal,dispatchOverlayLoad}) => {
    const { push } = useHistory();
    const dispatch = UseAppDispatch();
    const navigateToPreferAndSubs = UseAppSelector(getNavigateToPreferencesAndSubscription);

    useEffect(() => {
        const overlay = "Authenticated Number Change Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const handleSignUp = ()=>{
        if(navigateToPreferAndSubs){
            push('/workplace/en/participant/profile/index/preference.html')
            dispatch(setNavigateToPreferencesAndSubscription(false));
        }
        handleCloseModal();
    }

    const handleClose = ()=>{
        if(navigateToPreferAndSubs)
            dispatch(setNavigateToPreferencesAndSubscription(false));
        handleCloseModal();
    }
        const getFooter = () => {
        return <ReactModalFooter
            tertiaryButtonText={"Skip"}
            primaryButtonText={"Sign Up"}
            handleOnClick={handleSignUp}
            handleCancelClick={handleClose}
            primaryButtonId={ANALYTICS_IDS.SignUpModalSkipBtn}
            tertiaryButtonId={ANALYTICS_IDS.SignUpModalSignUpBtn}
        />
    };

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>
                <ReactModalContent>
                    <ReactModalHeader modalTitle="Sign up for text alerts"/>
                    Adding or changing your mobile number does not automatically sign you up for text alerts. To sign up
                    for text alerts for this plan, click “Sign Up” and switch the toggles to on.
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

